module.exports = __webpack_public_path__ + "img/img5.6bca79ca.svg";